import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";

const Layout4 = ({
  heading,
  Route,
  btnName,
  showAddButton = true,
  add_action,
  onAddBtClick,
  addButtonDisabled = false,
  addButtonLoading = false,
  subtitle,
}) => {
  const navigate = useNavigate();
  const { Permission } = usePermissionDataStore();

  const hasAddPermission = useMemo(() => {
    if (!add_action) return true;
    return (
      Permission &&
      Array.isArray(Permission) &&
      Permission.includes(add_action)
    );
  }, [add_action, Permission]);

  return (
    <div className="ems-page-head">
      <div>
        <h1 className="ems-page-title">{heading}</h1>
        {subtitle && (
          <div className="ems-page-sub">
            <span>{subtitle}</span>
          </div>
        )}
      </div>
      {showAddButton &&
        hasAddPermission &&
        btnName &&
        (Route || typeof onAddBtClick === "function") && (
        <div className="ems-head-actions">
          <button
            className="ems-btn ems-primary"
            disabled={addButtonDisabled || addButtonLoading}
            onClick={() => {
              if (typeof onAddBtClick === "function") {
                onAddBtClick();
                return;
              }
              navigate(`${Route}/add`);
            }}
          >
            {addButtonLoading ? (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}
              >
                <circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor"
                  strokeOpacity=".3" strokeWidth="2.5" fill="none" />
                <path d="M7.5 2A5.5 5.5 0 0 1 13 7.5" stroke="currentColor"
                  strokeWidth="2.5" strokeLinecap="round" fill="none" />
              </svg>
            ) : (
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                style={{ flexShrink: 0 }}>
                <line x1="7.5" y1="1.5" x2="7.5" y2="13.5" />
                <line x1="1.5" y1="7.5" x2="13.5" y2="7.5" />
              </svg>
            )}
            {btnName}
          </button>
        </div>
      )}
    </div>
  );
};

export default Layout4;
